import React from 'react';
import { createPortal } from 'react-dom';

import UpdateDuplicates from './UpdateDuplicates';

export default class FieldSettingsHead extends React.Component {
    render() {
        return createPortal(
            <UpdateDuplicates />,
            document.getElementById('viagf_update_dupes_app')
        );
    }
}
